import React, { useCallback, useContext, useMemo } from "react";
import { IAreasProps, IArea } from "../FailureDetailsInterfaces";
import { HMIContext } from "../../../../../contexts/HMIContext/HMIContext";
import { FailureDetailsButton } from "../../../../../components/FailureDetailsButton/FailureDetailsButton.view";
import { useStyles } from "../FailureDetails.styles";
import { Grid } from "@mui/material";
import { setCurrentArea } from "../../../../../utilities/storageUtilities";
import { useTranslation } from "react-i18next";
import { handleNameTranslation } from "utilities/localesUtilities";

export const FailureAreasButtons = ({ areas }: IAreasProps) => {
    const { handleArea, handleNextFailureDetailsStep } = useContext(HMIContext);
    const classes = useStyles();
    const { i18n } = useTranslation();

    const handleFailureArea = useCallback(
        (area: IArea) => {
            return (event: React.MouseEvent) => {
                event.preventDefault();
                handleArea(area);
                setCurrentArea(area);
                handleNextFailureDetailsStep();
            };
        },
        [handleArea, handleNextFailureDetailsStep],
    );

    const translatedButtonsNames = useMemo(
        () =>
            areas.map((area) => (
                <Grid item xs={5.8} key={area.area_id}>
                    <FailureDetailsButton
                        onClick={handleFailureArea(area)}
                        name={handleNameTranslation(i18n.language.slice(0, 2), area.translation.translation_names)}
                    />
                </Grid>
            )),
        [i18n.language, areas, handleFailureArea],
    );

    return (
        <Grid container className={classes.failureButtonsContainer}>
            {translatedButtonsNames}
        </Grid>
    );
};
